module.exports = __webpack_public_path__ + "static/media/compress-arrows-alt.e44c41b5.svg";